import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Transition from '../../utils/Transition';
import AuthService from 'api/services/AuthService';
import projet_image from 'assets/images/moncf_logo.png'
import { useTranslation } from 'react-i18next';

function UserMenu() {
  const { t } = useTranslation();

  const history = useHistory();
  const [currentUser, setCurrentUser] = useState(undefined);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });


  const handleLogOut = (dropdownStatus) => {
    AuthService.logout();
    // setDropdownOpen(dropdownStatus)
    history.push("/login"); // whichever component you want it to route to
  }


  useEffect(() => {
    const user =   AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
    }
  }, []);


  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <div className='bg-gray-50 h-8 w-8 border  rounded-full flex items-center justify-center'>
          <img className="w-6 bg-clip-border  rounded-full" src={projet_image} alt="User" />
        </div>
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium group-hover:text-gray-800">{currentUser?.email}</span>
          <svg className="w-3 h-3 shrink-0 ml-1 fill-current text-gray-400" viewBox="0 0 12 12">
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </button>

      <Transition
        className="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          role="menu"
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="pt-0.5 pb-2 px-3 mb-1 border-b border-gray-200">
            <div className="font-medium text-gray-800">ONCF</div>
            <div className="text-xs text-gray-500 italic">{currentUser?.email}</div>
          </div>
          <ul>
            {/* <li>
              <Link
                className="font-medium text-sm text-blue-500 hover:text-blue-600 flex items-center py-1 px-3"
                to="/profile/settings"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Settings
              </Link>
            </li> */}
            <li>
              <a
                className="font-medium text-sm text-blue-500 hover:text-blue-600 flex items-center py-1 px-3"
                onClick={handleLogOut}
                href='/logout'
              >
               {t('actions.logout')}
              </a>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  )
}

export default UserMenu;